import { ICommonResponse } from '../../types/CommonResponse.interface'
import { showAlert } from '../../../app/store/reducers/AppSlice'
import { AppDispatch } from '../../../app/store/Store'

export function handleCommonResponse(
  { success, errors }: ICommonResponse<unknown>,
  dispatch: AppDispatch,
  successMessage?: string,
): void {
  if (!success && errors) {
    const errorMessages = Array.isArray(errors)
      ? Object.values(errors).flat().join('\n')
      : Array.isArray(Object.values(errors)[0])
        ? Object.values(errors)[0]?.[0]
        : Object.values(errors)[0]

    dispatch(
      showAlert({
        message: errorMessages as string,
        timeout: 10000,
        type: 'error',
      }),
    )
  } else if (successMessage) {
    dispatch(
      showAlert({
        message: successMessage,
        type: 'success',
      }),
    )
  }
}
